import React from "react";
import { motion } from "framer-motion";
import RepoLanguage from "./RepoLanguage";
import { Link } from "react-router-dom";

function ProjectCard({ repo, toggleHide }) {
  const createdAt = new Date(repo.created_at).toLocaleDateString();

  return (
    <motion.div
      key={repo.id}
      className="bg-gradient-to-r from-zinc-500 to-zinc-950 text-white p-4 rounded-md shadow-md relative overflow-hidden border border-white"
      initial={{ opacity: 0, scale: 0.9 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ duration: 0.3 }}
      whileHover={{ scale: 1.05 }}
      whileTap={{ scale: 0.95 }}
    >
      <div className="relative">
        <motion.img
          src={repo.image_url}
          alt={repo.name}
          className="mb-4 w-full h-48 object-cover rounded-md"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.5, delay: 0.2 }}
        />
        <motion.h2
          className="text-lg font-bold text-center absolute inset-0 flex justify-center items-center text-white"
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.5, delay: 0.4 }}
          whileHover={{ scale: 1.1, color: "#000000" }}
        >
          {repo.name === "MovieApp"
            ? "MOVIE APP (React Native)"
            : repo.name.toUpperCase()}
        </motion.h2>
      </div>

      <motion.div
        className="flex items-center mb-4 justify-between"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.5, delay: 0.6 }}
      >
        <motion.div>
          <motion.a
            href={repo.html_url}
            target="_blank"
            className="bg-gradient-to-r from-black to-green-500 text-white px-4 py-2 rounded-md mr-4"
            whileHover={{
              backgroundImage: "linear-gradient(to left, black, green)",
              scale: 1.05,
            }}
            whileTap={{ scale: 0.95 }}
          >
            Go to Repo
          </motion.a>
          {repo.homepage && (
            <motion.a
              href={repo.homepage}
              target="_blank"
              rel="noopener noreferrer"
              className="bg-gradient-to-r from-black to-blue-500 text-white px-4 py-2 rounded-md"
              whileHover={{
                backgroundImage: "linear-gradient(to left, black, blue)",
                scale: 1.05,
              }}
              whileTap={{ scale: 0.95 }}
            >
              Live
            </motion.a>
          )}
        </motion.div>
        <motion.button
          className="p-1 rounded-full bg-red-200 text-black px-8 py-1"
          onClick={() => toggleHide(repo.id)}
          whileHover={{
            backgroundColor: "#b91c1c",
            color: "white",
            scale: 1.05,
          }}
          whileTap={{ scale: 0.95 }}
        >
          {repo.hidden ? "+" : "Remove"}
        </motion.button>
      </motion.div>
      <p className="absolute top-4 left-4 text-md font-bold text-white m-2">
        {createdAt}
      </p>
      {repo.language && <RepoLanguage language={repo.language} />}
      {repo.stargazers_count > 0 && (
        <p className="text-sm">
          <span className="text-xs font-bold">Stars:</span>{" "}
          {repo.stargazers_count}
        </p>
      )}
      <Link to={`/projects/${repo.id}`} key={repo.id}>
        <motion.button
          className="p-1 rounded-md bg-violet-400 text-white px-8 py-1 absolute top-4 right-4"
          whileHover={{ backgroundColor: "violet", scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
        >
          Details
        </motion.button>
      </Link>
    </motion.div>
  );
}

export default ProjectCard;
